import { axiosV2 } from 'interceptors/axios';
import { PaginationQueryProps } from 'modules/_shared/components/Pagination/Pagination';
import { decryptResponse } from 'utils/token';

type GetOperationsByPartner = {
  societyId: string;
  partnerId: string;
  filterBy?: string | string[];
  items?: number;
  params?: PaginationQueryProps;
};

export const getOperationsByPartner = async ({
  societyId,
  partnerId,
  filterBy,
  items = 100,
  ...params
}: GetOperationsByPartner) => {
  const query = {
    params: { societyId, partnerId, filterBy, items, ...params },
  };
  try {
    const { data } = await axiosV2.get('/operations', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    return [];
  }
};
